
import { Options, Vue } from "vue-class-component";
import { namespace } from 'vuex-class';
import CardRh from "@/components/cards/ManzaCard.vue";
import FaltaService from "@/service/v1/sigap/FaltaService";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import Multiselect from '@vueform/multiselect';
import { PerfilConfig } from "@/core/config/PerfisConfig";
import { User } from "@/store/modules/AuthModule";
import iziToast from 'izitoast';

const authStore = namespace('auth');

@Options({
    name: "FaltaMatriculaIndex",
    components: { CardRh, KDataTable, Multiselect },
})
export default class FaltaMatriculaIndex extends Vue {
    @authStore.Getter
    public perfis!: any;

    @authStore.Getter
    public currentUser!: User;

    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service: any = null;
    public modelo: any = null;
    public dados: any = null;
    public data_min: any = null;
    public data_max: any = null;
    public meses = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    public dias = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
    public situacao_id: any = null;
    public status_id: any = null;
    public matriculaId: any = null;
    public status: any = null;
    public situacoes: any = null;
    public numero = '';
    public disciplinaFiltro = '';

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get hasPermissaoEditar(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.data_min = null;
        this.data_max = null;
        this.status_id = null;
        this.situacao_id = null;
        this.numero = '';
        this.disciplinaFiltro = '';
        this.refreshTable();
    }

    get hj() {
        return new Date().getFullYear() + '-' + this.meses[new Date().getMonth()] + '-' + this.dias[new Date().getDate()];
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    get situacoes_select() {
        if (this.situacoes) {
            return this.situacoes.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public getSituacao() {
        this.processando = true;
        this.service.GetSituacao()
            .then(response => {
                this.situacoes = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public updateSituacao(id: any, situacaoId: any) {
        this.service.updateSituacao(id, situacaoId)
            .then(() => {
                this.refreshTable();
                iziToast.success({
                    title: 'OK',
                    position: 'topRight',
                    message: 'Situacao alterada com sucesso!',
                });
            })
            .catch(() => {
                iziToast.error({
                    title: 'Erro',
                    position: 'topRight',
                    message: 'Algo inesperado aconteceu!',
                });
            });
    }

    public tableatualizada() {
        document.querySelectorAll('.situacao-select-placeholder').forEach(placeholder => {
            placeholder.innerHTML = '';
            const faltaId = (placeholder as HTMLElement).dataset.faltaId;
            const situacaoId = (placeholder as HTMLElement).dataset.situacaoId;
            const select = document.createElement('select');
            select.classList.add('form-select', 'form-select-lg');
            select.add(new Option('Selecione', ''));
            if (this.situacoes_select) {
                this.situacoes_select.forEach(item => {
                    select.add(new Option(item.label.replaceAll('_', ' '), item.value));
                });
            }
            select.value = situacaoId ?? '';
            placeholder.appendChild(select);

            select.addEventListener('change', (e) => {
                const novoValor = (e.target as HTMLSelectElement).value;
                this.updateSituacao(faltaId, novoValor);
            });
        });
    }

    created() {
        this.matriculaId = this.$route.params.id;
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.service = new FaltaService();
        this.getSituacao();
        this.getStatus();
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    DataMin: this.data_min,
                    DataMax: this.data_max,
                    status: this.status_id,
                    disciplina: this.disciplinaFiltro,
                    matriculaId: this.matriculaId,
                    situacao: this.situacao_id,
                    numero: this.numero,
                    search: d.search.value,
                };
                return dados;
            }
        };
        this.config.order = [[0, 'desc'],[1, 'asc']];
        this.config.columns = [
            { data: 'data', name: 'data' },
            { data: 'disciplina', name: 'disciplina' },
            { data: 'aula', name: 'aula', class: 'desktop' },
            { data: 'faltaMotivo', name: 'faltaMotivo', class: 'desktop' },
            { data: 'faltaTipo', name: 'faltaTipo', class: 'desktop' },
            { data: 'status', name: 'status', searchable: false, class: 'text-center desktop' },
            { data: 'situacao', name: 'situacao', searchable: false, class: 'text-center desktop' },
        ];

        this.config.columnDefs = [
            {
                targets: 0,
                render: (row, type, val) => {
                    return SiteUtils.formatData(val.aula.data);
                }
            },
            {
                targets: 1,
                render: (row) => {
                    return row != null ? row.descricao : '';
                }
            },
            {
                targets: 2,
                render: (row) => {
                    return row != null ? row.numero : '';
                }
            },
            {
                targets: 3,
                render: (row) => {
                    return row.nome.replaceAll('_', ' ');
                }
            },
            {
                targets: 4,
                render: (row) => {
                    return row.nome.replaceAll('_', ' ');
                }
            },
            {
                targets: 5,
                render: (row) => {
                    return row.nome.replaceAll('_', ' ');
                }
            },
            {
                targets: 6,
                render: (row, type, val) => {
                    return `<div class="situacao-select-placeholder" data-falta-id="${val.id}" data-situacao-id="${val.situacao.id}"></div>`;
                }
            },
        ];
    }
}
